import { PushNotifications } from "@capacitor/push-notifications";

/**
 * Push permission as the OS reports it. `unavailable` is the web and any binary without the push
 * plugin: there is nothing to ask for, so it is never a reason to show a sheet.
 */
export type PushPermissionState = "granted" | "denied" | "prompt" | "unavailable";

export const checkPushPermission = async (): Promise<PushPermissionState> => {
  try {
    const { receive } = await PushNotifications.checkPermissions();

    if (receive === "granted") return "granted";
    if (receive === "denied") return "denied";
    return "prompt";
  } catch {
    return "unavailable";
  }
};
